import type { TWorkspaceRoleTier } from "@/types/workspace";

/**
 * Whether a member is a Guest: their System Role's License Tier is Guest
 * (NG-3903), the same test the backend makes (`eligibility`, NG-3052).
 *
 * Never compare `role` to `"workspace.guest"` to answer this. That slug is the
 * seeded Guest, which a workspace created on the built-in roles does not have:
 * its Guest-tier role is the Requester (`workspace.ootb.requester`), and a
 * customer's own Guest-tier role has a slug of its own. Only when the payload
 * carries no tier (a response from before the field shipped) does this fall
 * back to the seeded slug, which is what every caller checked before.
 */
export function isGuestTier(member: {
  role: string | null | undefined;
  tier?: TWorkspaceRoleTier | null;
}): boolean {
  if (member.tier != null) return member.tier === "guest";
  return member.role === "workspace.guest";
}
